// @owner ClientPlatform

import React from 'react';
import type {FC} from 'react';
import {styled} from 'styled-components';
import {textStyleMixin} from './text';

interface LegalTermsFooterProps {
  className?: string;
}

const StyledFooter = styled.div`
  ${textStyleMixin({$variant: 'caption-small-regular'})};
  color: var(--color-text-tertiary);
  text-align: center;

  a {
    ${textStyleMixin({$variant: 'caption-small-semibold'})};
  }
`;

export const LegalTermsFooter: FC<LegalTermsFooterProps> = ({className}) => (
  <StyledFooter className={className}>
    By clicking &quot;Continue&quot;, I acknowledge I have read and agreed to FrontApp, Inc.&apos;s&nbsp;
    <a
      href="https://front.com/legal/saas-services-agreement"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="General Terms (opens in new tab)"
    >
      General Terms
    </a>
    ,&nbsp;
    <a
      href="https://front.com/legal/supplemental-terms#ai_features_terms"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="AI Supplemental Terms (opens in new tab)"
    >
      AI Supplemental Terms
    </a>
    , and&nbsp;
    <a
      href="https://front.com/legal/privacy-notice"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Privacy Notice (opens in new tab)"
    >
      Privacy Notice
    </a>
    .
  </StyledFooter>
);
